import shareDirectives from './share'

// 导出所有指令的install集合
export default [shareDirectives]
